import { render } from "./DealCard.vue?vue&type=template&id=07bdeae9&scoped=true"
import script from "./DealCard.vue?vue&type=script&lang=js"
export * from "./DealCard.vue?vue&type=script&lang=js"

import "./DealCard.vue?vue&type=style&index=0&id=07bdeae9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bdeae9"]])

export default __exports__